<template>
  <help-info-wrapper
    :info.sync="helpData"
    :service-name="serviceName"
    class="warp"
  >
    <template>
      <v-card class="rounded-xl" flat>
        <v-card-title class="justify-center">{{
          $t("dsBasketCondition.title")
        }}</v-card-title>
        <v-card-text>
          <div class="rowinfo">
            <v-select
              v-model="computedValue.name"
              :items="translatedItems"
              :menu-props="{ offsetY: true }"
              class="rounded-lg"
              dense
              hide-details
              outlined
            />
            <help-info
              :element-name="`${serviceName}-${componentName}-computedValue-name`"
              :service-name="serviceName"
              :help-data="helpData"
              class="buttoninfo"
              :label="`${computedValue.name}`"
            />
          </div>
        </v-card-text>

        <template v-if="computedValue.name !== 'NoConditions'">
          <v-card-title class="justify-center">{{ displayTitle }}</v-card-title>
          <v-card-text>
            <div class="rowinfo">
              <v-text-field
                v-model="computedValue[computedValue['name']]"
                class="rounded-lg contentinfo"
                clearable
                dense
                hide-details
                hide-spin-buttons
                outlined
                type="number"
              />
              <help-info
                :element-name="`${serviceName}-${componentName}-computedValue-2-name`"
                :service-name="serviceName"
                :help-data="helpData"
                class="buttoninfo"
                :label="`${computedValue.name}`"
              />
            </div>
          </v-card-text>
        </template>
      </v-card>
    </template>
  </help-info-wrapper>
</template>

<script>
export default {
  name: "dsBasketCondition",

  props: {
    value: Object,
  },

  data: () => ({
    helpData: [],
    componentName: "dsBasketCondition",
    serviceName: "Qrland",
  }),

  computed: {
    computedValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    translatedItems() {
      return [
        {
          value: "NoConditions",
          text: this.$t("dsBasketCondition.items.NoConditions"),
        },
        {
          value: "MinimumShopping",
          text: this.$t("dsBasketCondition.items.MinimumShopping"),
        },
        {
          value: "MinimumProduct",
          text: this.$t("dsBasketCondition.items.MinimumProduct"),
        },
        {
          value: "MaximumShopping",
          text: this.$t("dsBasketCondition.items.MaximumShopping"),
        },
        {
          value: "MaximumProduct",
          text: this.$t("dsBasketCondition.items.MaximumProduct"),
        },
      ];
    },
    displayTitle() {
      return this.translatedItems.find(
        (item) => item.value === this.computedValue.name
      )?.text;
    },
  },

  watch: {
    "$i18n.locale": {
      handler() {
        this.$forceUpdate();
      },
      immediate: true,
      deep: true,
    },
    "computedValue.name"(val) {
      if (val === "NoConditions")
        this.computedValue = {
          name: "NoConditions",
        };
      else
        this.computedValue = {
          name: val,
          [val]: null,
        };
    },
  },
};
</script>

<style scoped></style>
